import { HomeSwitchOutlineIcon } from './HomeSwitchOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 4C8FD8F1-0690-4B2D-A614-A03F58D48370
 * name home-switch-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-switch-outline.svg
 * tags
 * - Home Automation 
 */
export const HouseSwapOutlineIcon = HomeSwitchOutlineIcon;
export default HouseSwapOutlineIcon